import React from 'react';
import Styled from 'styled';
import Img from 'lib/images/image-view';
import PhotoSwipeRoot, { bindEventsToRoot } from 'photoswipe/root/root';
import DefaultUi from 'photoswipe/default-ui/default-ui';
import PhotoSwipe from 'photoswipe';
import PhotoswipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default';

import defaultStyles, { ImageScss } from './image.scss';
import { CommentImageFragment } from './image.graphql';

export interface Props extends CommentImageFragment {
    sizes: { [media: string]: number };
    styles: ImageScss;
}

interface State {
    open: boolean;
}

const UI_OPTIONS = {
    closeEl: true,
    captionEl: false,
    fullscreenEl: true,
    zoomEl: false,
    shareEl: false,
    counterEl: false,
    arrowEl: false,
    preloaderEl: true,
};

class Image extends React.PureComponent<Props, State> {
    state: State = {
        open: false,
    };

    ref: HTMLImageElement | null = null;
    photoswipe: PhotoSwipe<any> | null = null;

    setRef = (ref: HTMLImageElement | null) => {
        this.ref = ref;
    };

    onResize = () => {
        if (this.photoswipe) {
            this.photoswipe.updateSize(true);
        }
    };

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    init = (ref: HTMLDivElement | null) => {
        if (ref) {
            const { width, src, height } = this.props;

            const item = {
                w: width!,
                src,
                h: height!,
            };

            const img = this.ref;

            // let getThumbBoundsFn;

            if (img) {
                (item as any).msrc = img.currentSrc || img.src;

                // getThumbBoundsFn = () => {
                //     const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                //     const rect = img.getBoundingClientRect();

                //     return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                // };
            }

            const photoswipe = bindEventsToRoot(
                new PhotoSwipe(ref, PhotoswipeDefaultUI, [item], {
                    ...UI_OPTIONS,
                    history: false,
                    // getThumbBoundsFn,
                })
            );

            this.photoswipe = photoswipe;

            photoswipe.init();

            photoswipe.listen('destroy', () => {
                this.setState(
                    {
                        open: false,
                    },
                    () => {
                        if (this.photoswipe === photoswipe) {
                            this.photoswipe = null;
                        }
                    }
                );
            });
        }
    };

    open = () => {
        this.setState({
            open: true,
        });
    };

    render() {
        const { styles, sizes, src, srcset } = this.props;
        return (
            <React.Fragment>
                <button className={styles.button} onClick={this.open}>
                    <Img forwardedRef={this.setRef} sizes={sizes} aspectFill={true} src={src} srcSet={srcset} />
                </button>
                {this.state.open ? (
                    <PhotoSwipeRoot forwardedRef={this.init}>
                        <DefaultUi {...UI_OPTIONS} />
                    </PhotoSwipeRoot>
                ) : null}
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(Image);
